import {
  Component
} from "@angular/core";
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import {
  IonicPage,
  NavController,
  NavParams,
  Platform,
  AlertController,
  ActionSheetController,
  ToastController,
  LoadingController
} from "ionic-angular";

import { PatientMedicationPage } from "../patient-medication/patient-medication";
import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider } from "../../providers/database/database";
import { PatientsPage } from "../patients/patients";
import _ from "lodash";


@IonicPage()
@Component({
  selector: "page-patient-add",
  templateUrl: "patient-add.html"
})
export class PatientAddPage {

  public continuousMode: boolean = false;
  patientForm: FormGroup;
  submitAttempt: boolean = false;
  patient: any = {};
  patientdata: any = {};
  ismobile = false;
  differentShipAddress: boolean = false;
  scannerActive: string = "barcode";
  lastImage: string;
  public error: string;
  public isExisting: boolean = false;
  public patientType: string = "New Patient";
  clinic_name: string = null;
  clinic_id: string = null;

  // Patient Form
  first_name: FormControl;
  last_name: FormControl;
  dob: FormControl;
  gender: FormControl;

  email: FormControl;
  phone_number_primary: FormControl;
  phone_number_work: FormControl;
  phone_number_other: FormControl;
  besttime: FormControl;

  address: FormControl;
  address2: FormControl;
  city: FormControl;
  province: FormControl;
  postal_code: FormControl;

  shipping_address: FormControl;
  shipping_address2: FormControl;
  shipping_city: FormControl;
  shipping_province: FormControl;
  shipping_postal_code: FormControl;

  shipping_address_toggle: FormControl;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private alertCtrl: AlertController,
    public actionSheetCtrl: ActionSheetController,
    public toastCtrl: ToastController,
    public platform: Platform,
    public loadingCtrl: LoadingController,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider
  ) {
    this.auth.getCurrentUser().then(user => {
      console.log(user);
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
    });

    this.first_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.last_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.dob = new FormControl("", Validators.required);
    this.gender = new FormControl("", Validators.required);
    this.email = new FormControl(
      "",
      Validators.compose([
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$")
      ])
    );
    this.phone_number_primary = new FormControl("", Validators.required);
    this.phone_number_work = new FormControl("");
    this.phone_number_other = new FormControl("");
    this.besttime = new FormControl("");

    this.address = new FormControl("", Validators.required);
    this.address2 = new FormControl("");
    this.city = new FormControl("", Validators.required);
    this.province = new FormControl("", Validators.required);
    this.postal_code = new FormControl("", Validators.required);

    this.shipping_address = new FormControl("");
    this.shipping_address2 = new FormControl("");
    this.shipping_city = new FormControl("");
    this.shipping_province = new FormControl("");
    this.shipping_postal_code = new FormControl("");

    this.shipping_address_toggle = new FormControl(false);

    this.patient = formBuilder.group({
      first_name: this.first_name,
      last_name: this.last_name,
      dob: this.dob,
      gender: this.gender,
      email: this.email,
      phone_number_primary: this.phone_number_primary,
      phone_number_work: this.phone_number_work,
      phone_number_other: this.phone_number_other,
      besttime: this.besttime,
      address: this.address,
      address2: this.address2,
      city: this.city,
      province: this.province,
      postal_code: this.postal_code,
      shipping_address_toggle: this.shipping_address_toggle,
      shipping_address: this.shipping_address,
      shipping_address2: this.shipping_address2,
      shipping_city: this.shipping_city,
      shipping_province: this.shipping_province,
      shipping_postal_code: this.shipping_postal_code
    });

    if (this.navParams.get("patient")) {
      this.patientdata = this.navParams.get("patient");
      this.patient.patchValue(this.patientdata);
      if (this.patientdata["shipping_address"]) {
        this.patient.controls["shipping_address_toggle"].setValue(true);
      } else {
        this.patient.controls["shipping_address_toggle"].setValue(false);
      }

      this.isExisting = true;
      this.patientType = "Edit " + this.patientdata.first_name;
      console.log("Existing Patient Info: ", this.patientdata);
    }
    this.patient["insurance_image"] = null;
    this.patient["insurance_image_type"] = null;

    if (platform.is("ios") || platform.is("android")) {
      this.ismobile = true;
    }
  }

  onInsuranceUrlEmitted(file) {
    console.log("URL From Component: ", file.url);
    this.patient.insurance_image = file.url;
    this.patient.insurance_image_type = file.type;
  }

  savePatient(addPrescription: boolean) {
    let confirm = this.alertCtrl.create({
      title: "Save This Patient?",
      message: "Are you sure you want to save this patient?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't save patient right now");
          }
        },
        {
          text: "Yes",
          handler: () => {
            this.patientdata = this.patient.value;
            this.patientdata["full_name"] = this.patientdata["first_name"] + ' ' + this.patientdata["last_name"];
            if(!this.patientdata["besttime"] || this.patientdata["besttime"] === '')  {
              this.patientdata["besttime"] = 'Not specified';
            }
            this.patientdata["insurance_image"] = this.patient.insurance_image;
            this.patientdata["insurance_image_type"] = this.patient.insurance_image_type;
            this.database
              .addPatient(this.clinic_id, this.patientdata)
              .then((patient_id) => {
                console.log("Response from patient save: ", patient_id);
                this.patientdata.id = patient_id;
                if(addPrescription) {
                  this.patientdata['study'] = {};
                  this.patientdata.study['completed'] = false;
                  this.patientdata.study['name'] = null;
                  this.patientdata.study['updatedAt'] = null;
                  let patientdata2 = {
                    patient: this.patientdata,
                    existingpatient: false
                  };
                  this.navCtrl.push(PatientMedicationPage, patientdata2);
                }
                else {
                  this.navCtrl.popTo(PatientsPage);
                }

              })
              .catch(err => {
                const toast = this.toastCtrl.create({
                  message:
                    "The patient could not be added.  The email address has to be unique and all fields appropriately filled out.  Please confirm and try again.",
                  duration: 3000
                });
                toast.present();
                console.log(
                  "There was a problem saving the patient info: ",
                  err
                );
              });
          }
        }
      ]
    });
    confirm.present();
  }

  updatePatient() {
    let confirm = this.alertCtrl.create({
      title: "Update This Patient?",
      message: "Are you sure you want to update this patient information?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't update patient right now");
          }
        },
        {
          text: "Yes",
          handler: () => {
            let tempid = this.patientdata.id;
            this.patientdata = this.patient.value;
            this.patientdata["id"] = tempid;
            this.patientdata["full_name"] = this.patientdata["first_name"] + ' ' + this.patientdata["last_name"];
            // let dateofbirth = new Date(this.patient["dob"]);
            // this.patientdata["day"] = dateofbirth.getDate() + 1;
            // this.patientdata["month"] = dateofbirth.getMonth() + 1;
            // this.patientdata["year"] = dateofbirth.getFullYear();
            this.patientdata["insurance_image"] = this.patient.insurance_image;
            this.patientdata["insurance_image_type"] = this.patient.insurance_image_type;
            this.database.updatePatient(this.clinic_id, this.patientdata).then(() => {
              console.log("Updated Patient");
              this.navCtrl.pop();
            })
              .catch(err => {
                const toast = this.toastCtrl.create({
                  message:
                    "There was an error updating this patient.  If you changed the email address, please make sure that it has not been used before for another patient.",
                  duration: 3000
                });
                toast.present();
                console.log(
                  "There was a problem saving the patient info: ",
                  err
                );
              });
          }
        }
      ]
    });
    confirm.present();
  }

  updatePatientFromBarcode(ev) {
    // Get First Name from DL
    this.patientdata["first_name"] = ev["first_name"];

    // Get Last Name from DL
    this.patientdata["last_name"] = ev["last_name"];

    // Get DOB from DL
    this.patientdata["dob"] = ev["dob"];

    // Get Gender from DL
    this.patientdata["gender"] = ev["gender"];

    this.patientdata["address"] = ev["address"];

    this.patientdata["city"] = ev["city"];
    this.patientdata["province"] = ev["province"];
    this.patientdata["postal_code"] = ev["postal_code"];

    this.patient.patchValue(this.patientdata);
  }

  bestTime = ["Morning", "Afternoon", "Evening"];

  provinces = [
    { short: "AB", name: "Alberta", country: "CA" },
    { short: "BC", name: "British Columbia", country: "CA" },
    { short: "MB", name: "Manitoba", country: "CA" },
    { short: "NB", name: "New Brunswick", country: "CA" },
    {
      short: "NL",
      name: "Newfoundland and Labrador",
      country: "CA",
      alt: ["Newfoundland", "Labrador"]
    },
    { short: "NS", name: "Nova Scotia", country: "CA" },
    { short: "NU", name: "Nunavut", country: "CA" },
    { short: "NT", name: "Northwest Territories", country: "CA" },
    { short: "ON", name: "Ontario", country: "CA" },
    { short: "PE", name: "Prince Edward Island", country: "CA" },
    { short: "QC", name: "Quebec", country: "CA" },
    { short: "SK", name: "Saskatchewan", country: "CA" },
    { short: "YT", name: "Yukon", country: "CA" }
  ];
}



// WEBPACK FOOTER //
// ./src/pages/patient-add/patient-add.ts